<header [class.scrolled]="isScrolled">
  <div class="container header-container">
    <div class="logo">
      <a href="#home">
        <img src="https://www.kotha.com.bd/assets/home/img/kothaLogo.png" alt="Kotha Logo" class="header-logo-img">
      </a>
    </div>

    <div class="mobile-controls">
      <!-- Theme Toggle for Mobile -->
      <button class="theme-toggle desktop-hide" (click)="themeService.toggleTheme()" [attr.aria-label]="themeService.theme() === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'" [title]="themeService.theme() === 'dark' ? 'Light theme' : 'Dark theme'">
        <svg *ngIf="themeService.theme() === 'dark'" class="theme-icon sun-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="5"></circle>
          <line x1="12" y1="1" x2="12" y2="3"></line>
          <line x1="12" y1="21" x2="12" y2="23"></line>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
          <line x1="1" y1="12" x2="3" y2="12"></line>
          <line x1="21" y1="12" x2="23" y2="12"></line>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
        </svg>
        <svg *ngIf="themeService.theme() === 'light'" class="theme-icon moon-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
      </button>

      <button class="mobile-toggle" (click)="toggleMenu()">
        <span class="hamburger" [class.open]="isMenuOpen"></span>
      </button>
    </div>

    <nav class="nav-menu" [class.active]="isMenuOpen">
      <ul class="nav-links">
        <li><a href="#" (click)="scrollToSection('home', $event)">Home</a></li>
        <li><a href="#" (click)="scrollToSection('services', $event)">Services</a></li>
        <li><a href="#" (click)="scrollToSection('portfolio', $event)">Portfolio</a></li>
        <li><a href="#" (click)="scrollToSection('how-it-works', $event)">How it works</a></li>
        <li><a href="#" (click)="scrollToSection('pricing', $event)">Pricing</a></li>
        <li><a href="#" (click)="scrollToSection('about-us', $event)">About</a></li>
        <li><a href="#" (click)="scrollToSection('contact-form', $event)">Contact</a></li>
      </ul>
      <div class="nav-actions">
        <!-- Theme Toggle -->
        <button class="theme-toggle mobile-hide" (click)="themeService.toggleTheme()" [attr.aria-label]="themeService.theme() === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'" [title]="themeService.theme() === 'dark' ? 'Light theme' : 'Dark theme'" id="theme-toggle-btn">
          <!-- Sun Icon (shown in dark mode, to indicate switching to light) -->
          <svg *ngIf="themeService.theme() === 'dark'" class="theme-icon sun-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="5"></circle>
            <line x1="12" y1="1" x2="12" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="23"></line>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
            <line x1="1" y1="12" x2="3" y2="12"></line>
            <line x1="21" y1="12" x2="23" y2="12"></line>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
          </svg>
          <!-- Moon Icon (shown in light mode, to indicate switching to dark) -->
          <svg *ngIf="themeService.theme() === 'light'" class="theme-icon moon-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
        </button>
        <a href="#" (click)="scrollToSection('contact-form', $event)" class="btn btn-primary nav-btn">Get a Quote</a>
      </div>
    </nav>
  </div>
</header>
